(function() { window.GUID_8f2e65fb_4111_477f_8545_ff271f6332d6 = { getGuid: function() { return "8f2e65fb-4111-477f-8545-ff271f6332d6"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class DropDownPicker extends Controls.ControlValueBase {
            OnBindEvents() {
                let me = this;
                //#########################################################
                /*
                             ATTENTION QUE SI ON TENTE DE FAIRE MARCHER FOCUS, DE TESTER PARTOUT,
                             SURTOUT LA SCORE SHEET PARCE QUE CA RENTRE EN CONFLIT AVEC LE CLICK, ETC
                             */
                //#########################################################
                this.$Picker
                    .offon("click." + this.ControlId, function (e) {
                    const isEventDropdownClick = me.ControlId.includes("cs-event-dropdown");
                    if (isEventDropdownClick) {
                        CS.Analytics.Event("Events", "Event dropdown clicked", `Wall - ${CS.Helper.GetWallTypeString(CS.CommonData.Current.Navigation.WallType)}`, CS.CommonData.Current.Navigation.WallType);
                    }
                    e.stopImmediatePropagation();
                    me.DropDown.SetCurrentPicker(me);
                    me.OnClick(e);
                })
                    .offon("keydown." + this.ControlId, function (e) {
                    me.DropDown.SetCurrentPicker(me);
                    me.DropDown.OnKeyDown(e);
                    me.TextSelected = false;
                    let keyPressed = CS.GetKeyPressed(e);
                    if (keyPressed == CS.Enums.KeyCode.Enter) {
                        e.preventDefault();
                        me.DropDown.Close();
                    }
                })
                    .offon("keyup." + this.ControlId, function (e) {
                    me.DropDown.SetCurrentPicker(me);
                    me.DropDown.OnKeyUp(e);
                });
                Controls.ListEvents.Refreshed({
                    selector: me.DropDown,
                    callback: (control, data) => {
                        me.testIfSelectedValueOfThePickerStillExistInList();
                    },
                });
            }
            OnSelectionChange(data) {
                let me = this;
                me.Datas = data;
                me.updateValueAndTextOfThePicker();
                me.$Picker.trigger("change", me.Datas); //Doit rester, utilisé dans la score sheet
                me.Trigger(DropDownPicker.EventNames.PickerSelectionChanged, { jqueryEventObject: null, data });
            }
            OnDispose() {
                this.$Picker
                    .off("click." + this.ControlId)
                    .off("keydown." + this.ControlId)
                    .off("keyup." + this.ControlId);
            }
            get ControlId() {
                if (this.pickerId)
                    return this.pickerId;
                let id = this.$Picker.attr("id");
                if (id) {
                    return id;
                }
                return this.DropDown.ControlId + "_" + this.UniqueInstanceId + "Picker";
            }
            get $Control() {
                return this.$Picker;
            }
            Is(selector) {
                if (selector == this) {
                    return true;
                }
                else if (this.$Picker.is(selector)) {
                    return true;
                }
                return false;
            }
            SetValue(value, bypassEvent = false) {
                this.val(value, bypassEvent);
            }
            val(value, bypassEvent = false) {
                if (typeof value !=
                    "undefined" /*important de garder cette approche dans ce cas précis et non juste if(value)*/) {
                    if (value != null) {
                        let splitted = value.toString().split(",");
                        this.Datas = this.DropDown.GetDatasBasedOnValues(splitted);
                    }
                    else {
                        this.Datas = null;
                    }
                    this.updateValueAndTextOfThePicker(bypassEvent);
                }
                else {
                    return this.$Picker.val();
                }
            }
            ClearValue() {
                this.SetValue(null);
                this.Datas = null;
            }
            GetValue() {
                var _a;
                if (this.Datas != null)
                    return (_a = this.Datas[0]) === null || _a === void 0 ? void 0 : _a.value;
                return null;
            }
            get ParentDropDown() {
                if (!this.parentDropDownSearched) {
                    let $parentDropDown = this.$Picker.closest(".dropdown");
                    if ($parentDropDown.length > 0) {
                        this.parentDropDown = CS.Controls.GetInstance(Controls.DropDown, $parentDropDown);
                        let parentZIndex = this.parentDropDown.$DropDown.css("z-index");
                        this.DropDown.$DropDown.css("z-index", parentZIndex + 1);
                    }
                    this.parentDropDownSearched = true;
                }
                return this.parentDropDown;
            }
            get IsASearchBox() {
                return this.$Picker.hasClass("is-a-searchbox");
            }
            get IsAnInput() {
                return this.$Picker.is(":input") && !this.$Picker.is("button");
            }
            constructor(dropDownInstance, picker) {
                super(dropDownInstance, picker);
            }
            OnControlInstantiation(params) {
                this.DropDown = params[0];
                this.$Picker = params[1];
                this.pickerId = this.$Picker.attr("id");
                this.$Picker.addClass("dropdown-picker");
                if (this.$Picker.length > 0) {
                    this.defaultInnerHTML = this.$Picker[0].innerHTML;
                    this.Parameters = this.$Picker.data("parameters");
                }
                if (this.Parameters) {
                    if (this.Parameters.HiddenToAppend) {
                        this.$Hidden = $(this.Parameters.HiddenToAppend);
                        this.$Hidden.insertBefore(this.$Picker);
                    }
                    if (this.Parameters.DisplayArrowAtRight) {
                        this.$Picker.addClass("display-arrow-at-right");
                    }
                    if (this.Parameters.DisplayArrowAtLeft) {
                        this.$Picker.addClass("display-arrow-at-left");
                    }
                }
                this.Datas = this.DropDown.GetDatasBasedOnValues(this.$Picker.data("datas"));
                this.updateValueAndTextOfThePicker(undefined, true);
                if (!this.$Picker.is("input") && !this.$Picker.attr("tabindex")) {
                    this.$Picker.attr("tabindex", 1000000);
                }
                this.$Picker.data("dropdown-picker", this);
                if (this.$Picker.parents(".is-premium-locked").length > 0 ||
                    this.$Picker.hasClass("disabled")) {
                    this.$Picker.attr("disabled", "disabled");
                    return;
                }
                if (this.DropDown.Parameters.ShowOnLoad) {
                    this.ShowDropDown();
                }
            }
            OnClick(e) {
                if (!this.TextSelected) {
                    this.$Picker.select();
                    this.TextSelected = true;
                }
                if (this.DropDown.IsVisible && this.DropDown.CurrentPicker == this) {
                    this.DropDown.Close(this);
                }
                else {
                    this.Trigger(DropDownPicker.EventNames.PickerClicked);
                    if (!this.ShowOnlyByGetAndShowWhenClick) {
                        this.ShowDropDown();
                    }
                }
            }
            HideDropDown() {
                this.DropDown.Close(this);
            }
            ShowDropDown() {
                let me = this;
                requestAnimationFrame(function () {
                    if (me.IsASearchBox) {
                        me.DropDown.SearchEvenIfNoText = me.Parameters.SearchEvenIfNoText;
                        me.DropDown.PassItemsThroughFilterAndShow(me);
                    }
                    else {
                        me.DropDown.ClearFilter(true);
                        me.DropDown.Show(me);
                    }
                });
            }
            ConvertToSearchBox() {
                this.$Picker.addClass("is-a-searchbox");
            }
            testIfSelectedValueOfThePickerStillExistInList() {
                let me = this;
                if (me.IsASearchBox) {
                    return;
                }
                if (me.Datas) {
                    let listDatas = me.DropDown.ItemsDatas;
                    let listEnd = listDatas.length;
                    let pickerDatasEnd = me.Datas.length;
                    let dataExist = false;
                    if (me.Datas) {
                        for (var i = 0; i < listEnd; i++) {
                            for (var j = 0; j < pickerDatasEnd; j++) {
                                let listCurrentItemDatas = listDatas[i];
                                if (listCurrentItemDatas.value == me.Datas[j].value) {
                                    dataExist = true;
                                    break;
                                }
                            }
                        }
                    }
                    if (!dataExist) {
                        me.Datas = null;
                        me.updateValueAndTextOfThePicker();
                    }
                }
            }
            updateValueAndTextOfThePicker(bypassEvent = false, isInitiating = false) {
                var _a, _b;
                const overrideLabel = this.$Picker.attr("data-overridelabel");
                if (isInitiating && !CS.Helper.isNullOrWhiteSpace(overrideLabel)) {
                    this.$Picker.val(overrideLabel);
                    if (this.$Hidden && !bypassEvent) {
                        this.$Hidden.val(overrideLabel).trigger("change");
                    }
                    return;
                }
                let text = "";
                let values = "";
                if (this.Datas && this.Datas.length > 0) {
                    let end = this.Datas.length;
                    for (var i = 0; i < end; i++) {
                        if (i > 0) {
                            text += ", ";
                            values += ",";
                        }
                        let value = this.Datas[i];
                        if ((_a = value.extraValues) === null || _a === void 0 ? void 0 : _a.displayText) {
                            text += (_b = value.extraValues) === null || _b === void 0 ? void 0 : _b.displayText;
                        }
                        else {
                            text += value.innerText;
                        }
                        values += value.value;
                    }
                }
                if (this.DropDown.Parameters.SetInnerTextOfThePickerOnSelection) {
                    if (!text) {
                        text = this.defaultInnerHTML;
                    }
                    if (this.$Picker.is(":input")) {
                        this.$Picker.val(text);
                    }
                    else {
                        this.$Picker[0].innerHTML = text;
                        this.$Picker.val(values);
                    }
                }
                if (!this.Datas) {
                    this.$Picker.val(null);
                }
                if (this.$Hidden && !bypassEvent) {
                    this.$Hidden.val(values).trigger("change");
                }
            }
        }
        Controls.DropDownPicker = DropDownPicker;
        (function (DropDownPicker) {
            class Events extends Controls.ControlValueBase.Events {
                static ListItemClicked(param) {
                    return Controls.ListEvents.ItemClicked(param);
                }
                static ListSelectionChanged(param) {
                    return Controls.ListEvents.SelectionChanged(param);
                }
                /**
                 * Register a callback handler when the value changed inside the picker. It return an unbind function.
                 */
                static SelectionChanged(param) {
                    Controls.RegisterEvent(DropDownPicker, EventNames.PickerSelectionChanged, param);
                }
                static Clicked(param) {
                    Controls.RegisterEvent(DropDownPicker, EventNames.PickerClicked, param);
                }
            }
            DropDownPicker.Events = Events;
            class EventNames extends Controls.ControlValueBase.EventNames {
            }
            EventNames.PickerSelectionChanged = "dropdown-picker-selection-changed";
            EventNames.PickerClicked = "dropdown-picker-clicked";
            DropDownPicker.EventNames = EventNames;
        })(DropDownPicker = Controls.DropDownPicker || (Controls.DropDownPicker = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=dropdown-picker.js.map
